<template>
<div class="page">
    <div class="imgbox">
        <img src="../assets/smartcabinet/s1.png" alt="">
        <img src="../assets/smartcabinet/s2.png" alt="">
        <img src="../assets/smartcabinet/s3.png" alt="">
        <img src="../assets/smartcabinet/s4.png" alt="">
    </div>
</div>
</template>

<script>
export default {
    name: "SmartCabinet"
};
</script>

<style>
.imgbox{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
}
.imgbox img{
    width: 1190px;
    height: auto;
}
.page{
    height: auto;
    background: #fff;
    margin: 0 auto;
    width: 1190px;
}
</style>
